import { HelpersService } from './tools/helpers.service';
import { AutenticacionService } from './autenticacion.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable()
export class AutenticacionGuard implements CanActivate {
  constructor(private router: Router, private authService: AutenticacionService, private helperService: HelpersService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.getUser()
            .pipe(map(data => {
              const content = data.json().content;
              console.log('AutenticacionGuard', content);
              this.authService.setUser(content);
              const permissions = this.authService.hasPermission(next.data.modulo); // get the data setting on routes file

              if (! permissions) {
                const next_modulo = this.authService.getFirstPermittedRoute();
                this.router.navigate([next_modulo]); // sending to a enable module
              }

              return permissions;
            }), catchError((error) => {
              console.log('err ', error);
              this.helperService.httpGlobalError(error);
              return Observable.throw(error.statusText);
            }));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/autenticacion.guard.ts